import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBlog, faExternalLinkAlt, faSearch, faTasks, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Home from "./components/fidelior-home.vue";
 
library.add(faBlog, faExternalLinkAlt, faSearch, faTasks, faUpload)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuelidate)

Vue.config.productionTip = false

const routes = [
  { path: '/', component: Home },
]

const router = new VueRouter({
  routes
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

